<div id="custom-fields">
  <div>
    <div class="main_profile modal-content d-flex flex-column">
      <div class="modal-header switch_header">
        <ng-container>
          <div class="col-lg-12 col-xl-12 col-12">
            <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
              {{ headerText }}
            </h3>
          </div>
        </ng-container>
      </div>
      <div class="modal-body bg-white body-content">
        <ng-container *ngIf="topErrorMessages.length > 0">
          <div class="row err" *ngFor="let msg of topErrorMessages">
            <div class="col-md-12 mb-1">
              <p class="col-md-12 error" id="err">{{ msg }}</p>
            </div>
          </div>
        </ng-container>
        <div class="row" *ngIf="topErrorMessages.length === 0 && errorMsg">
          <div class="col-md-12 error">
            {{ errorMsg }}
          </div>
        </div>
        <ng-container>
          <div class=" details col-lg-12 col-md-12 px-sm-5 px-0">
            <form [formGroup]="updateCustomFieldDetailForm" (ngSubmit)="onSubmit()">
              <div class="form-group row align-items-center">
                <div class="col-sm-5 col-12">
                  <label class="head">
                    Custom Field Name:<i class="required-icon">*</i>
                  </label>
                  <small class="form-text text-muted" style="margin:-2% 0 -2%">
                   (max 25 characters).
                  </small>
                </div>
                <div class="col-sm-7 col-12">
                  <input
                    type="text"
                    formControlName="customFieldName"
                    class="form-control"
                    maxlength="25"
                    required
                  />
                  <small class="text-danger"
                         *ngIf="submitted && updateCustomFieldDetailForm.get('customFieldName')?.invalid">
                    <span *ngIf="updateCustomFieldDetailForm.get('customFieldName')?.hasError('required')">
                      Custom Field Name is required.
                    </span>
                                      <span *ngIf="updateCustomFieldDetailForm.get('customFieldName')?.hasError('maxlength')">
                      Max 25 characters.
                    </span>
                  </small>
                </div>
              </div>
              <div class="form-group row">
                <label class="head col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 padding-rl-0">
                  Required?<i class="required-icon">*</i>
                </label>
                <div class="col-md-7 col-lg-7 col-sm-7 col-12 col-xl-7 pl-1 mt-2 pl-m-10">
                  <div class="row m-0 col-6">
                    <div class="col-sm-12 col-12 d-flex justify-content-between p-0">
                      <label class="form-check-label role pb-1">
                        <input
                          class="custom-checkbox mt-0"
                          type="radio"
                          formControlName="Required"
                          [value]="true"
                        />
                        Yes
                      </label>
                      <label class="form-check-label role pb-1">
                        <input
                          class="custom-checkbox mt-0"
                          type="radio"
                          formControlName="Required"
                          [value]="false"
                        />
                        No
                      </label>
                    </div>
                    <small class="text-danger"
                           *ngIf="submitted && updateCustomFieldDetailForm.get('Required')?.invalid">
                      Please select Yes or No.
                    </small>
                  </div>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="head col-sm-5 col-12">Datatype accepted:<i class="required-icon">*</i></label>
                <span class="error_sign" id="name2">!</span>
                <div class="col-sm-7 col-12">
                  <select formControlName="datatype" class="form-control">
                    <option value="" disabled>Select...</option>
                    <option *ngFor="let type of customFieldTypes" [value]="type.value">{{ type.label }}</option>
                  </select>
                  <small class="text-danger" *ngIf="updateCustomFieldDetailForm.get('datatype')?.hasError('required') && updateCustomFieldDetailForm.get('datatype')?.touched">
                    Please select a datatype.
                  </small>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <div class="col-sm-5 col-12">
                  <label class="head">
                    Description:
                  </label>
                  <small class="form-text text-muted" style="margin:-2% 0 -2%">
                    (max 100 characters).
                  </small>
                </div>
                <div class="col-sm-7 col-12">
                  <textarea
                    type="text"
                    formControlName="description"
                    class="form-control"
                    maxlength="100"
                  > </textarea>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
      </div>
      <ng-container>
        <div class="modal-footer custom-footer">
          <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()">
            Cancel
          </button>
          <button class="btn btn-default lg-btn ok-btn" (click)="onSubmit()" id="myTooltip">
            Save Custom Field
          </button>
        </div>
      </ng-container>
    </div>

  </div>
</div>
